import HeroHeader from 'modules/common/HeroHeader';
import NextButton from 'modules/common/NextButton';
import PropTypes from 'prop-types';
import React from 'react';
import {useIntl} from 'react-intl';
import {connect} from 'react-redux';
import {compose, setPropTypes} from 'recompose';
import {updateNoteProgress} from '../actions';
import Note from '../components/Note';

const NoteContainer = (props) => {
  const intl = useIntl();
  const {formatMessage} = intl;
  const {nextStepProps, step, completeProgress, trackSlug, isDegree} = props;
  return (
    <div>
      <HeroHeader title={step.name} trackSlug={trackSlug} isDegree={isDegree} />
      <Note title={step.note.title} description={step.note.description} />
      <div className="pv5 pv3-m pl6-ns pl0-m pl0 tl-ns tc-m tc">
        <NextButton
          {...nextStepProps}
          pretext={`${formatMessage({
            id: 'continue',
          })} :`}
          completeProgress={completeProgress}
        />
      </div>
    </div>
  );
};

NoteContainer.propTypes = {
  nextStepProps: PropTypes.object.isRequired,
  step: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  completeProgress: PropTypes.func.isRequired,
  trackSlug: PropTypes.string.isRequired,
  isDegree: PropTypes.bool.isRequired,
};

const mapDispatchToProps = (dispatch, {relatedSteps, step: {id}}) => ({
  completeProgress: () => {
    dispatch(
      updateNoteProgress({
        id,
        completed: true,
        related_steps: relatedSteps,
      }),
    );
  },
});

const enhance = compose(
  setPropTypes({
    relatedSteps: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  }),
  connect(null, mapDispatchToProps),
);

export default enhance(NoteContainer);
